import React from 'react';
import { Select } from 'src/components/';
import COMMON_CONSTANTS from 'common/commonConstants';

const { GOALS, getGoalStatusValueByKey } = COMMON_CONSTANTS;

const FilterByStatus = ({
  id,
  companyid,
  status,
  options,
  updateFn,
  customSelectClasses,
  showXButton = true
}) => {
  const statusOptions = options ?? [
    ...Object.keys(GOALS.STATUS).map((key) => ({
      id: GOALS.STATUS[key],
      label: getGoalStatusValueByKey(key, companyid),
      checked: status && status.includes(GOALS.STATUS[key])
    }))
  ];

  let filterByStatusTitle = 'Filter by status';

  if (status && status.length) {
    if (status.length === 1) {
      filterByStatusTitle = '1 status selected';
    } else {
      filterByStatusTitle = `${status.length} statuses selected`;
    }
  }

  const updateSelectedStatus = (key) => {
    let newStatus = [...status];
    const exists = newStatus && newStatus.includes(key);
    if (exists) {
      newStatus = newStatus.filter((value) => value !== key);
    } else {
      newStatus.push(key);
    }

    return updateFn({ status: newStatus });
  };

  const clearStatusFilter = () => updateFn({ status: [] });

  return (
    <Select
      id={id}
      variant='shadow'
      multiselect
      title={filterByStatusTitle}
      options={statusOptions}
      onChange={(option) => updateSelectedStatus(option.id)}
      classes={customSelectClasses ?? 'w-60'}
      showXButton={showXButton && status && status.length}
      onClickXButton={clearStatusFilter}
    />
  );
};

export default FilterByStatus;
